import DirectiveListPage from "@/pages/common/DirectiveListPage";

const InstructionPage: React.FC = () => {
  return <DirectiveListPage title='지시/방침 사항 관리' />;
};

export default InstructionPage;
